<template>
  <TransactionTemplate
    :getHeaderToolbar="getHeaderToolbar"
    :screenJson="getScreenJson"
    :headerScreenJson="getHeaderScreenJson"
    :setLoading="setLoading"
    :localDataGrid="false"
    :backButtonRoute="getBackButtonRoute"
    ref="freight-label"
    :data-model="getDataModel"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
    :warningSummary="warningSummary"
    :tabs="{}"
  />
</template>
<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import TransactionTemplate from "../../templates/transaction.vue";
import ApiService from "../../_services/api/api.service";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      setLoading: false,
      loaded: false,
      reload: false,
      validationSummary: [],
      serverError: {},
      warningSummary: [],
      saveEndpoint: "AlmondcoFreightLabels",
      backRoute: "/almondco-freight-labels",
      dataModel: {
        LotNo: undefined,
        LotSequenceNo: undefined,
        BinCardNo: undefined,
        ProductCode: undefined,
        BranchCode: undefined,
        RecordId: undefined,
        DepotDocket: undefined,
        SeasonYear: undefined,
      },
    };
  },
  computed: {
    getBackButtonRoute() {
      return this.backRoute;
    },
    getDataModel() {
      return this.dataModel;
    },
    getHeaderToolbar() {
      return {
        headerToolbar: {
          screenName: "Freight Label Create",
          pdf: false,
          audit: false,
          status: false,
          notes: false,
          save: true,
          saveCallback: this.saveFreightLabel,
        },
      };
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          title: {
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: undefined,
                text: "Create",
              },
            },
            secondary: {
              dataField: undefined,
              text: "Freight label",
            },
          },
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "LotNo",
                      dataField: "LotNo",
                      required: true,
                      editorType: "dxNumberBox",
                      editorOptions: {
                        customFormat: true,
                        format: "#",
                        min: 1,
                      },
                    },
                    {
                      screenField: "SequenceNo",
                      dataField: "LotSequenceNo",
                      allowUpdate: true,
                      visible: true,
                      required: true,
                      editorType: "dxNumberBox",
                      editorOptions: {
                        customFormat: true,
                        format: "#",
                        min: 1,
                        max: 40,
                      },
                    },
                    {
                      screenField: "BinCardNo",
                      dataField: "BinCardNo",
                      allowUpdate: true,
                      required: true,
                      editorType: "dxNumberBox",
                      editorOptions: {
                        customFormat: true,
                        format: "#",
                        min: 1,
                      },
                    },
                    {
                      screenField: "DepotDocket",
                      dataField: "DepotDocket",
                      allowUpdate: true,
                      required: false,
                      editorType: "dxNumberBox",
                      editorOptions: {
                        customFormat: true,
                        format: "#",
                        min: 1,
                      },
                    },
                    {
                      screenField: "SeasonYear",
                      dataField: "SeasonYear",
                      allowUpdate: true,
                      required: true,
                      editorType: "dxNumberBox",
                      editorOptions: {
                        value: new Date().getFullYear(),
                        customFormat: true,
                        format: "#",
                        min: 1,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      };
    },
    getScreenJson() {
      return {
        title: "Freight Labels",
        endpoint: {
          primary: undefined,
        },
        footerData: {
          footerItems: [],
        },
      };
    },
  },
  async created() {
    this.initialized();
  },
  methods: {
    async saveFreightLabel() {
      // Save the data to the AlmondcoInshellBinLotAssignment table
      // this stores the Lot and Sequence #s for Bins
      await ApiService.post("api/AlmondcoInshellBinLotAssignment", {
        DepotDocket: `${this.dataModel.DepotDocket}`,
        SeasonYear: this.dataModel.SeasonYear,
        BinCardNo: this.dataModel.BinCardNo,
        LotNo: this.dataModel.LotNo,
        LotSequenceNo: this.dataModel.LotSequenceNo,
        // FumigantCode cannot be null. Pass an empty string.
        FumigantCode: "",
      })
        .then(() => {
          this.setIgnoreRouteChangeConfirmation();
          this.$notify("Successfully created the Freight Label");
          this.$router.push({ path: `/almondco-freight-labels` });
        })
        .catch((err) => {
          this.setLoading = false;
          this.serverError = {
            err: err,
            msg: "Save failed",
            time: new Date().getTime(),
          };
        });
    },
    async initialized() {
      this.loaded = true;
    },
  },
};
</script>
